import { TRANSLITERATE_URL } from "../../../../utils/constants";

export const getTransliterateSuggestions = async (word, config) => {
  const { showCurrentWordAsLastSuggestion = true, lang = "hi" } = config || {};



  try {
    const res = await fetch(TRANSLITERATE_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        text: word,
        source_language: "en",
        target_language: lang,
        num_suggestions: 4,
      }),
    });

    if (!res.ok) {
      throw new Error(`Transliteration API failed with status ${res.status}`);
    }

    const data = await res.json();
    const result = Array.isArray(data?.suggestions)
      ? data.suggestions
      : Array.isArray(data?.suggestions_list)
        ? data.suggestions_list
        : [];

    const suggestions = result.length > 0 ? result : [];

    if (suggestions.length > 0) {
      return showCurrentWordAsLastSuggestion
        ? [...new Set([...suggestions, word])]
        : suggestions;
    }

    return showCurrentWordAsLastSuggestion ? [word] : [];
  } catch (e) {
    console.error("There was an error with transliteration", e);
    return showCurrentWordAsLastSuggestion ? [word] : [];
  }
};
